exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ntable[data-v-05a175c5] {\n  width: 50%;\n  margin: auto;\n}\n.evenRow[data-v-05a175c5] {\n  background-color: #ffffcc\n}\ntable tr[data-v-05a175c5]:hover {\n  background-color: #ffcccc\n}\n.schoolTab a[data-v-05a175c5]{\n  font-size: 20px;\n  margin: 5px;\n  background-color: rgba(141, 143, 159, 0.48);\n  border-radius: 5px;\n}\n.selected[data-v-05a175c5]{\n  border-bottom: solid 5px rgba(72, 200, 139, 0.52);\n}\n.classroom-name[data-v-05a175c5] {\n  font-size: 16px; /* 通常のフォントサイズに設定 */\n  line-height: 1.5; /* 行間を適度に広くする */\n  padding: 5px; /* <pre>タグに少し余白を追加 */\n  white-space: pre-wrap; /* 改行を保持しつつ、折り返しも行う */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-05a175c5","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ManagementPage/EditClassroomPage.vue
// module id = 470
// module chunks = 0